// extracted by mini-css-extract-plugin
module.exports = {"FooterAwards":"styles_FooterAwards__v7KXy","height":"styles_height__6hf9Z"};